import React, { Component } from "react";
import { Styled } from "../../../toolkit/decorators/Artifact";
import TotalPassDetalle from "../../../types/TotalPassDetalle";
import s from "./styles.scss";
import { userHasPermission } from "../../../utils/accessTree";
import permissionCodes from "../../../utils/permissionCodes";

const { MENU_MEMBRESIA_SOCIO } = permissionCodes;

interface Props {
  detalle: TotalPassDetalle;
}
interface State {}

@Styled(s)
export default class TotalPassDetalleInfo extends Component<Props, State> {
  render() {
    const totalPass = this.props.detalle;
    const membresiaLabel = `${totalPass.idPublico} de ${totalPass.club}`;

    return (
      <div className={`row ${s.details}`}>
        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Membresía</h5>
            {totalPass.idMembresiaSocio ? (
              userHasPermission(MENU_MEMBRESIA_SOCIO) ? (
                <a
                  href={`/membresias-socios/${totalPass.idMembresiaSocio}?idClub=${totalPass.idClubBase}&idPublico=${totalPass.idPublico}`}
                  target="_blank"
                >
                  {membresiaLabel}
                </a>
              ) : (
                membresiaLabel
              )
            ) : (
              "No"
            )}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Correo</h5>
            {totalPass.correo || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Blacklist</h5>
            {totalPass.vetado ? "Sí" : "No"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Eliminado</h5>
            {totalPass.eliminado ? "Sí" : "No"}
          </div>
        </div>
      </div>
    );
  }
}
